import { nanoid } from 'nanoid'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { Operation } from '@apollo/client/core'
import * as crypoto from '@/utils/crypto'
import useUrlParams from '@/views/news/hooks/useUrlParams'
import * as storage from '@/utils/storage'

dayjs.extend(utc)

interface Sign {
  'gh-nonce': string
  'gh-deviceid': string
  'gh-date': string
  'gh-token': string
  'gh-bodyhash': string
  'gh-appid': string
  'gh-sign': string
}

export default function signWrap(operation?: Operation): Sign {
  const { appId, appSecret } = useUrlParams()
  let paramsBody: any = {}
  if (operation) {
    const { query: queryOper, operationName, variables } = operation
    const queryBody = queryOper.loc?.source.body
    paramsBody = {
      operationName,
      query: queryBody,
      variables
    }
  }
  const { sessionId: token, deviceId: deviceid }: any = storage.get('userInfo') || {}
  const nonce = nanoid()
  const date = dayjs.utc().format().replace(/(-|:)/g, '')
  const bodyHash = crypoto.sha256Encrypt(JSON.stringify(paramsBody)).toUpperCase()
  const appid = appId

  const signStr = `GH-DEVICEID:${deviceid},GH-TOKEN:${token},GH-DATE:${date},GH-NONCE:${nonce},GH-BODYHASH:${bodyHash},GH-APPID:${appid}`
  const signName = crypoto.hmacSha256Encrypt(signStr, appSecret).toUpperCase()

  return {
    'gh-nonce': nonce,
    'gh-deviceid': deviceid,
    'gh-date': date,
    'gh-token': token,
    'gh-bodyhash': bodyHash,
    'gh-appid': appid,
    'gh-sign': signName
  }
}
